import { Dispatcher } from '@npm-registry/helpers/dispatcher';

// Пользователь получил данные по корзине
export const FetchCartFulfilled = new Dispatcher();

// Пользователь открыл пустую корзину
export const CartEmptyLoaded = new Dispatcher();

// Пользователь кликнул по кнопке 'К акциям' в пустой корзине
export const SaleButtonClicked = new Dispatcher();

// Пользователь в пустой корзине кликнул по кнопке 'На главную' в пустой корзине
export const GoToMainButtonClicked = new Dispatcher();

// Пользователь кликнул по кнопке 'В избранное' в пустой корзине
export const FavouriteButtonClicked = new Dispatcher();

// Пользователь успешно применил промокод
export const PromocodeAppliedSuccess = new Dispatcher();

// Не удалось применить промокод
export const PromocodeAppliedFailed = new Dispatcher();

// Пользователь кликнул по кнопке 'Перейти к оформлению'
export const SubmitButtonClicked = new Dispatcher();

// Пользователь кликнул по блоку оплаты частями
export const InstallmentInformerToggle = new Dispatcher();

// Пользователь успешно добавил товар в корзину
export const ProductAddedSuccessfully = new Dispatcher();

// Пользователь успешно добавил рекомендуемый товар в корзину
export const RecommendationProductAddedSuccessfully =
  new Dispatcher();

// Пользователь успешно удалил товар из корзины
export const ProductRemovedSuccessfully = new Dispatcher();

// Пользователь успешно удалил товар из корзины
export const ProductReturnedSuccessfully = new Dispatcher();

// Пользователь успешно очистил корзину
export const CartEmptiedSuccessfully = new Dispatcher();

// Отображение блок "Рекомендуем также" в пределах экрана
export const RecommendationProductBlockVisible =
  new Dispatcher();
